<template>
    <single-select :config="config" :key="config.storeField"></single-select>
</template>
<script>
    import SingleSelect from '../template/SingleSelect';

    export default {
        components: {SingleSelect},
        data: function () {
            return {
                config: {
                    question: 'Would you like to update your emergency contact?',
                    options: [
                        'Yes',
                        'No'
                    ],
                    storeField: 'update_emergency_contact_question',
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function (value) {
                        if (value === 'Yes') {
                            await this.$router.push('/reg/emergencyContact')
                        } else {
                            await this.$router.push('/reg/updateMedicalRecords')
                        }
                    }.bind(this)
                }
            }
        }
    }
</script>

